import { IFormBuilderForm } from "../../model/formBuilderForm";
import { IFormBuilderRowSettings } from "../../model/formBuilderRow";

export interface IUpdateRowSettingsActionPayload {
  key: string;
  prevRowSettings: IFormBuilderRowSettings;
  nextRowSettings: IFormBuilderRowSettings;
}

export interface IUpdateRowSettingsAction {
  type: "UPDATE_ROW_SETTINGS";
  payload: IUpdateRowSettingsActionPayload;
}

export function getUpdateRowSettingsInverseAction(
  action: IUpdateRowSettingsAction,
): IUpdateRowSettingsAction {
  return {
    type: "UPDATE_ROW_SETTINGS",
    payload: {
      key: action.payload.key,
      prevRowSettings: action.payload.nextRowSettings, 
      nextRowSettings: action.payload.prevRowSettings,
    },
  };
}

export function applyUpdateRowSettingsChange(
  form: IFormBuilderForm,
  action: IUpdateRowSettingsAction,
): IFormBuilderForm {
  const { key, nextRowSettings } = action.payload;

  return {
    ...form,
    children: form.children.map(row => {
      if (row.key === key) {
        return {
          ...row,
          data: {
            ...row.data,
            settings: {
              ...nextRowSettings,
            },
          },
        };
      } else {
        return row;
      }
    }),
  };
}
